import { Location } from "@/lib/api";

/**
 * Reorder a list of locations to match the given order of ids.
 *
 * Tolerant of a mismatch between `locations` and `ids`:
 * - ids that do not match a location are ignored
 * - duplicate ids are applied only once
 * - locations whose id is absent from `ids` keep their relative order and are
 *   appended after the reordered ones
 *
 * Used for optimistic cache updates while a reorder mutation is in flight.
 */
export function reorderLocationsByIds(locations: Location[], ids: string[]): Location[] {
  const byId = new Map(locations.map((location) => [location.id, location]));
  const ordered: Location[] = [];
  const seen = new Set<string>();

  for (const id of ids) {
    const location = byId.get(id);
    if (location && !seen.has(id)) {
      ordered.push(location);
      seen.add(id);
    }
  }

  for (const location of locations) {
    if (!seen.has(location.id)) {
      ordered.push(location);
    }
  }

  return ordered;
}
